import { render, staticRenderFns } from "./daftar-bimbingan.vue?vue&type=template&id=5930df91"
import script from "./daftar-bimbingan.vue?vue&type=script&lang=js"
export * from "./daftar-bimbingan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports